export default __webpack_public_path__ + "static/media/photo11.4fdf6678.jpg";